export enum TriggerType {
  Click = 'click',
  Hover = 'hover',
}
